/**
 * @function ApiClient#GetNotifyBarList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetNotifyBarList(cid, options = {}) {
  return await this._get(`/community/${cid}/notify_bar_list`, options);
}
